import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { MessageService, SelectItem } from "primeng/api";
import { environment } from "src/environments/environment";
import { MyserviceService } from "../myservice.service";

@Component({
    selector: "app-user-creation",
    templateUrl: "./user-creation.component.html",
    styleUrls: ["./user-creation.component.css"],
    providers: [MessageService],
})
export class UserCreationComponent implements OnInit {
    userRole: string;
    partnerData: any = [];
    selectedPartners: any = [];
    disableCreate: boolean
    disablePartnerDD: boolean;
    loader: boolean;
    showB2BPart: boolean;
    showSfgPart: boolean;
    sfgPartnerData: any = [];
    selectedSfgPartners: any = [];
    timeZones: any = [];
    isProd:boolean=environment.prod;
    constructor(
        private myservice: MyserviceService,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        private fb: FormBuilder,
        private http: HttpClient,
        private messageService: MessageService
    ) { }

    rolesArray = [];
    ROLES: any = [];
    userCreationForm: FormGroup;
    user: any = {
        firstName: "",
        lastName: "",
        email: "",
        officePhone: "",
        status: "-1",
        roleId: "-1",
        departmentId: "-1",
        createdBy: "",
    };
    public responseViewTime: boolean = false;
    resultMessage = "";
    departmentOptions = [];
    roleOptions: SelectItem[];
    status = [];
    role: SelectItem[];
    previewOptions: any = [{ key: '-1', label: "Select" }, { key: false, label: "No" }, { key: true, label: "Yes" }]
    ngOnInit() {
        this.getTimeZones();
        this.getPartnersLookupData();
        this.getSfgPartnersLookupData();
        this.userRole = this.session.retrieve("userRole");
        this.userCreationForm = this.fb.group({
            firstName: new FormControl("", Validators.required),
            lastName: new FormControl("", Validators.required),
            email: new FormControl("", [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
            officePhone: new FormControl("", Validators.required),
            timeZone: new FormControl("", Validators.required),
            status: new FormControl("", Validators.required),
            roleId: new FormControl("", Validators.required),
            departmentId: new FormControl("", Validators.required),
            partnerIds: new FormControl([]),
            sfgPartnersNames: new FormControl([]),
            fileVisibility: new FormControl({ key: false, label: 'No' }, Validators.required),
        });
        //Add partner access functionality is limited upto QA environment
        if (!this.isProd) {
            this.userCreationForm.addControl('addPartnersAccess', new FormControl({ key: false, label: 'No' }, Validators.required));
        }
        this.rolesArray.push({
            label: "Select Role Type",
            value: "-1",
        });

        this.rolesArray = this.myservice.getMscvpRoles(
            this.localstorage.retrieve("token")
        );

        this.user.firstName = "";
        this.user.lastName = "";
        this.user.email = "";
        this.user.officePhone = "";
        this.user.status = "-1";
        this.user.roleId = "-1";
        this.user.departmentId = "-1";
        this.departmentOptions.push({
            label: "Select",
            value: "-1",
        });

        this.departmentOptions.push({ label: "Management", value: "1" });
        this.departmentOptions.push({ label: "Operations", value: "2" });
        this.departmentOptions.push({ label: "Development", value: "3" });

        this.status.push({
            label: "Select",
            value: "-1",
        });
        this.status.push({ label: "ACTIVE", value: "A" });
        this.status.push({ label: "INACTIVE", value: "I" });
        this.status.push({ label: "TERMINATED", value: "T" });
    }
    //To get list of timezones and patch est as default value
    getTimeZones() {
        this.myservice.getTimeZones(this.localstorage.retrieve("token")).subscribe((res) => {
            this.timeZones = res;
            this.userCreationForm.controls["timeZone"].patchValue(this.timeZones.filter((res) => res.id == "est")[0])
        })
    }
    add(user) {
        this.selectedSfgPartners = [];
        this.selectedPartners = [];
        if (this.userCreationForm.invalid) {
            const controls = this.userCreationForm.controls;
            Object.keys(controls).forEach((key) => {
                controls[key].markAsTouched();
            });
        }
        else {
            this.loader = true;
            this.disableCreate = true
            this.userCreationForm.value.partnerIds.forEach(element => {
                this.selectedPartners.push(element.value)
            });
            this.userCreationForm.value.sfgPartnersNames.forEach(element => {
                this.selectedSfgPartners.push(element.label)
            });
            let timeZone = this.userCreationForm.value.timeZone.id
            this.selectedPartners = this.partnerData.length === this.selectedPartners.length ? ["ALL"] : this.selectedPartners;
            this.selectedSfgPartners = this.sfgPartnerData.length === this.selectedSfgPartners.length ? ["ALL"] : this.selectedSfgPartners
            this.user = {
                ...user, "partnerIds": this.selectedPartners, "sfgPartnersNames": this.selectedSfgPartners,
                "fileVisibility": this.userCreationForm.value.fileVisibility.key,
                "timeZone": timeZone
            };
            if (!this.isProd) {
                this.user["addPartnersAccess"]= this.userCreationForm.value.addPartnersAccess.key
            }
            this.user.createdBy = this.session.retrieve("UserDetails").loginId;
            this.resultMessage = "";
            let headers = new HttpHeaders();
            headers = headers.append(
                "authorization",
                this.localstorage.retrieve("token")
            );
            this.http
                .post(environment.apiUrl + "/user/add", this.user, {
                    headers: headers,
                    responseType: "text",
                })
                .subscribe((data) => {
                    this.loader = false;
                    this.disableCreate = false
                    this.resultMessage = data;
                    if (this.resultMessage == "User created successfully.") {
                        this.reset();
                        this.messageService.add({
                            severity: "success",
                            detail: this.resultMessage,
                        });
                    } else {
                        this.messageService.add({
                            severity: "error",
                            detail: this.resultMessage,
                        });
                    }
                    this.responseViewTime = true;
                    setTimeout(
                        function () {
                            this.responseViewTime = false;
                        }.bind(this),
                        2000
                    );
                });
        }
    }

    reset() {
        this.showB2BPart = false;
        this.showSfgPart = false;
        this.userCreationForm.reset();
        this.userCreationForm.controls["timeZone"].patchValue(this.timeZones.filter((res) => res.id == "est")[0])
    }
    getPartnersLookupData() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(environment.apiUrl + "/partner/all", { headers: headers })
            .subscribe(
                (data: any) => {
                    this.partnerData = data;
                    this.partnerData = this.partnerData.filter((data) => { return !environment.amcPartnerIds.includes(data.value) });
                    this.partnerData = this.partnerData.map(element => ({ ...element, optionLabel: `${element.label}(${element.value})` }))
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            )
    }
    getSfgPartnersLookupData() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(environment.apiUrl + "/sfg/partnerVisibility", { headers: headers })
            .subscribe(
                (data: any) => {
                    let keys = Object.keys(data);
                    for (var i = 0; i < keys.length; i++) {
                        this.sfgPartnerData.push({
                            label: data[keys[i]],

                        });
                    }
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            )
    }
    setPartners(data) {
        let bothRoles = [1, 6, 7];
        let partRoles = [1, 2, 3, 6, 7];
        let sfgPartRoles = [1, 4, 5, 6, 7];
        if (data === 1) {
            this.userCreationForm.get("partnerIds").patchValue(this.partnerData);
            this.userCreationForm.get("fileVisibility").patchValue({ key: true, label: "Yes" });
            !this.isProd&&this.userCreationForm.get("addPartnersAccess").patchValue({ key: true, label: "Yes" });
            this.userCreationForm.get("sfgPartnersNames").patchValue(this.sfgPartnerData);
            this.disablePartnerDD = true;
        }
        else {
            this.userCreationForm.get("partnerIds").patchValue([]);
            this.userCreationForm.get("fileVisibility").patchValue({ key: false, label: "No" });
            !this.isProd&&this.userCreationForm.get("addPartnersAccess").patchValue({ key: false, label: "No" });
            this.userCreationForm.get("sfgPartnersNames").patchValue([])
            this.disablePartnerDD = false;
        }
        //To show partner visibility dropdown and set validators
        if (bothRoles.includes(data)) {
            this.showB2BPart = true;
            this.showSfgPart = true;
            this.userCreationForm.get("partnerIds").setValidators([Validators.required])
            this.userCreationForm.get("sfgPartnersNames").setValidators([Validators.required])
        } else if (partRoles.includes(data)) {
            this.showB2BPart = true;
            this.showSfgPart = false;
            this.userCreationForm.get("partnerIds").setValidators([Validators.required])
            this.userCreationForm.get("sfgPartnersNames").setValidators([])
        }
        else if (sfgPartRoles.includes(data)) {
            this.showB2BPart = false;
            this.showSfgPart = true;
            this.userCreationForm.get("partnerIds").setValidators([])
            this.userCreationForm.get("sfgPartnersNames").setValidators([Validators.required])
        }
        this.userCreationForm.get("partnerIds").updateValueAndValidity()
        this.userCreationForm.get("sfgPartnersNames").updateValueAndValidity()
    }
}
